module.exports = __webpack_public_path__ + "static/media/loc2_img8.1494f5c0.jpg";